import { Epic, ofType } from "redux-observable";
import { Observable, of } from "rxjs";
import { mergeMap, switchMap } from "rxjs/operators";
import { catchErrorWithDispatch } from "../../../libs/utils/errors";
import { QuotationRepository } from "../../../repositories/quotation.repository";
import { RootState } from "../../reducers";
import { QuotationActions } from "../actions";
import {
    QuotationCalculate,
    QuotationGetPreQuotationValues,
    SaveQuotation,
    SaveQuotationDone,
} from "../actions/default";
import {
    CALCULATE_QUOTATION,
    QUOTATION_GET_PRE_QUOTATION_VALUES,
    SAVE_QUOTATION,
} from "../constants";

export const quotationGetPreQuotationValuesEpic: Epic<
    QuotationActions,
    QuotationActions,
    RootState
> = (action$: Observable<QuotationActions>) =>
    action$.pipe(
        ofType(QUOTATION_GET_PRE_QUOTATION_VALUES),
        switchMap((action) =>
            QuotationRepository.getPreQuotationValues(
                action as QuotationGetPreQuotationValues
            )
        )
    );

export const calculateQuotationEpic: Epic<
    QuotationActions,
    QuotationActions,
    RootState
> = (action$: Observable<QuotationActions>) =>
    action$.pipe(
        ofType(CALCULATE_QUOTATION),
        mergeMap((action) =>
            QuotationRepository.calculateQuotation(action as QuotationCalculate)
        )
    );

export const saveQuotationEpic: Epic<
    QuotationActions,
    QuotationActions,
    RootState
> = (action$: Observable<QuotationActions>, state$) =>
    action$.pipe(
        ofType(SAVE_QUOTATION),
        switchMap((action) => {
            action.payload = QuotationRepository.getQuotationBody(state$);

            return QuotationRepository.saveQuotation(action as SaveQuotation);
        }),
        catchErrorWithDispatch((err) => of(new SaveQuotationDone(err).create()))
    );
